export enum ModalAction {
    Save = 'Save',
    SaveAndReturn = 'SaveAndReturn',
    SaveAndAddOneMore = 'SaveAndAddOneMore',
    Update = 'Update',
    UpdateAndReturn = 'UpdateAndReturn'
}
